import schema from "./schema.json";

const READMIN_OBJECT_TYPES = schema.possibleTypes.find((e) => e[0] === "ReadminObject")[1];
export default READMIN_OBJECT_TYPES;
